import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../authentication/components/AuthProvider';

const ProtectedRouteAdmin = () => {
  const { userData } = useContext(AuthContext);
  
  if (!userData || !userData.is_admin) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};

export default ProtectedRouteAdmin;
